module.exports = __webpack_public_path__ + "static/media/fondo_sin_nubes.1331f19e.png";